(() => {
  const pending = new Set();
  const loaded = new Set();

  const load = (placeholder) => {
    if (!placeholder || !pending.has(placeholder)) return;
    const source = placeholder.dataset.kecLazySrc;
    pending.delete(placeholder);
    if (!source || loaded.has(source)) return;

    loaded.add(source);
    const script = document.createElement('script');
    script.src = source;
    script.async = false;
    document.head.appendChild(script);
  };

  const initialize = () => {
    const placeholders = Array.from(document.querySelectorAll('[data-kec-lazy-src]'));
    placeholders.forEach((placeholder) => pending.add(placeholder));

    const onIntent = (event) => {
      pending.forEach((placeholder) => {
        const selector = placeholder.dataset.kecLazyTrigger;
        if (selector && event.target instanceof Element && event.target.closest(selector)) load(placeholder);
      });
    };

    document.addEventListener('pointerover', onIntent, { passive: true, capture: true });
    document.addEventListener('focusin', onIntent, { passive: true, capture: true });
    document.addEventListener('touchstart', onIntent, { passive: true, capture: true });

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const placeholder = placeholders.find((item) => item.dataset.kecLazyTarget === entry.target.dataset.kecLazyTarget);
          load(placeholder);
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '600px 0px' });

      placeholders.forEach((placeholder, index) => {
        const selector = placeholder.dataset.kecLazyObserve;
        const target = selector ? document.querySelector(selector) : null;
        if (!target) return;
        const key = `kec-lazy-${index}`;
        placeholder.dataset.kecLazyTarget = key;
        target.dataset.kecLazyTarget = key;
        observer.observe(target);
      });
    } else {
      placeholders.filter((item) => item.dataset.kecLazyObserve).forEach(load);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
